import { Component, OnInit, Input } from '@angular/core';
import { ApprovedAddress } from '../../index';

@Component({
  selector: 'app-approved-addresses',
  templateUrl: './approved-addresses.component.html',
  styleUrls: ['./approved-addresses.component.scss']
})
export class ApprovedAddressesComponent implements OnInit {

  @Input() addresses: ApprovedAddress[];

  constructor() { }

  ngOnInit() {
  }

  getDistinctAddressesWithApartmentsTogether() {
    // turn our addresses into a list of things like: 123 Dr. APTs: 1, 2A, 3, 4, A

    // reduce the addresses to an object whose property names are the address without the apartment and values are array of apartment numbers
    const reducedAddresses = this.addresses.reduce((accumulator, address) => {
      if (!accumulator[address.addressWithoutApartment]) {
        accumulator[address.addressWithoutApartment] = [];
      }
    
      accumulator[address.addressWithoutApartment].push(` ${address.apartmentNumber}${address.apartmentLetter}`);

      return accumulator;
    }, {});

    let groupedAddresses: any = [];
    for (const key in reducedAddresses) {
      const address = {header: key, apartmentNumbers: null};
      if (reducedAddresses[key].length > 1) {
        address.header += 's: ';
        address.apartmentNumbers = reducedAddresses[key];
      }
      groupedAddresses.push(address);
    }

    return groupedAddresses;
    }
}
